/**
 * Hook for fetching plots.
 */

import { gql, useQuery } from "@apollo/client";

export interface Plot {
  id: string;
  projectId: string;
  name: string;
}

interface PlotConnection {
  items: Plot[];
  totalCount: number;
  hasNextPage: boolean;
}

interface PlotsQueryResult {
  plots: PlotConnection;
}

const GET_PLOTS = gql`
  query GetPlots($limit: Int, $offset: Int) {
    plots(limit: $limit, offset: $offset) {
      items {
        id
        projectId
        name
      }
      totalCount
      hasNextPage
    }
  }
`;

export function usePlots() {
  const { data, loading, error } = useQuery<PlotsQueryResult>(GET_PLOTS, {
    variables: { limit: 200, offset: 0 },
    fetchPolicy: "cache-and-network",
  });

  return {
    plots: (data?.plots.items || []) as Plot[],
    totalCount: data?.plots.totalCount || 0,
    loading,
    error,
  };
}
